import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";

// Define fields for zones and bins
export const zonesBinsMappingFields = `
          id
          uniqueId
          binNumber
          isActive
`;

export const zonesBinsFields = `
      id
      uniqueId
      name
      bins {
        id
        uniqueId
        binNumber
        isActive
      }
`;

// Queries

export const GET_ZONE_BIN_MAPPING = gql`
    query GetZoneAndBinMapping($filtering: ZonesBinsMappingFilteringObject) {
        getZoneAndBinMapping(filtering: $filtering) {
            response {
                ${responseField}
            }
            page {
                ${basePageableGraphqlField}
            }
            data {
                ${zonesBinsMappingFields}
            }
        }
    }
`;

export const GET_ALL_BIN = gql`
    query getAllBins($filtering: BinsFilteringObject) {
        getAllBins(filtering: $filtering) {
            response {
                ${responseField}
            }
            page {
                ${basePageableGraphqlField}
            }
            data {
                ${zonesBinsMappingFields}
            }
        }
    }
`;

export const CREATE_ZONES_BINS_MAPPING = gql`
    mutation CreateZonesBinsMapping($input: ZonesBinsMappingInputObject!) {
        createZonesBinsMapping(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${zonesBinsMappingFields}
            }
        }
    }
`;

export const UPDATE_ZONES_BINS_MAPPING = gql`
    mutation UpdateZonesBinsMapping($input: ZonesBinsMappingInputObject!) {
        updateZonesBinsMapping(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${zonesBinsMappingFields}
            }
        }
    }
`;

export const DELETE_ZONES_BINS_MAPPING = gql`
    mutation DeleteZonesBinsMapping($uniqueId: String!) {
        deleteZonesBinsMapping(uniqueId: $uniqueId) {
            response {
                ${responseField}
            }
        }
    }
`;
